import * as React from 'react';
import { ReactElement, useState } from 'react';
import Button from 'components/common/Button';
import { deleteBackOrder } from 'api/backorder';
import DeleteBackOrderModal from 'components/backorder/modal/DeleteBackOrderModal';
import styled from '@emotion/styled';

interface Props {
  status: string;
  subscriptionId: number;
  reservedCredit: number;
}
const DeleteBackOrderButton = ({ status, subscriptionId, reservedCredit }: Props): ReactElement => {
  const [commentValue, setCommentValue] = useState<string>('');
  const [deleteBackOrderModalVisibility, setDeleteBackOrderModalVisibility] =
    useState<boolean>(false);

  const onChangeComment = (value: string): void => {
    setCommentValue(value);
  };

  const onClickDelete = (): void => {
    setDeleteBackOrderModalVisibility(true);
  };

  const onSubmit = async (): Promise<void> => {
    await deleteBackOrder({ subscriptionId, comment: commentValue });
    window.location.reload();
  };

  const onClose = (): void => {
    setCommentValue('');
    setDeleteBackOrderModalVisibility(false);
  };
  return (
    <>
      <Wrapper>
        <div>
          {status}
          <br />
          {reservedCredit} Credit
        </div>
        <Button variant="contained" size="small" color="primary" onClick={onClickDelete}>
          Delete
        </Button>
      </Wrapper>
      {deleteBackOrderModalVisibility && (
        <DeleteBackOrderModal
          commentValue={commentValue}
          onChangeComment={onChangeComment}
          onClose={onClose}
          onSubmit={onSubmit}
          isSubmitDisabled={!commentValue}
        />
      )}
    </>
  );
};

export default DeleteBackOrderButton;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
